import { $isRangeSelection, $isTextNode, type BaseSelection } from 'lexical';

export function applyStyle(
    selection: null | BaseSelection,
    property: string,
    value: string,
    shouldMerge: boolean = true
): void {
    if ($isRangeSelection(selection)) {
        const extractedNodes = selection.extract();
        for (const node of extractedNodes) {
            if ($isTextNode(node)) {
                const existingStyle = shouldMerge ? node.getStyle() : null;
                const mergedStyle = mergeStyle(existingStyle, property, value);
                node.setStyle(mergedStyle);
            }
        }
    }
}

export default function mergeStyle(
    originalStyle: string | null,
    key: string,
    value: string
): string {
    const styleMap: Record<string, string> = {};

    if (originalStyle) {
        originalStyle.split(';').forEach((pair) => {
            const [k, v] = pair.split(':').map((s) => s.trim());
            if (k && v) {
                styleMap[k] = v;
            }
        });
    }

    styleMap[key] = value;

    return Object.entries(styleMap)
        .map(([k, v]) => `${k}: ${v}`)
        .join('; ');
}
